import { LegalEntityFormFieldNames } from 'features/new-actor/enums/legalEntityFormFieldNames';
import { LegalEntityFormValues } from 'features/new-actor/types/legalEntityFormValues';
import { ValidationRules } from 'helpers/createFormConfig';
import * as Yup from 'yup';
import { addressValidationRules } from './addressValidationRules';
import { baseLegalEntityValidationRules } from './baseLegalEntityValidationRules';
import { personalInformationValidationRules } from './personalInformationValidationRules';

export const legalEntityValidationRules: ValidationRules<Exclude<keyof LegalEntityFormValues, 'id'>> =
{
  ...addressValidationRules,
  ...baseLegalEntityValidationRules,
  ...personalInformationValidationRules,
  [LegalEntityFormFieldNames.CompanyName]: Yup.string()
    .trim()
    .required('Ce champ est requis'),

  [LegalEntityFormFieldNames.CompanyRole]: Yup.string()
    .trim()
    .required('Ce champ est requis'),
}
